module.exports = __webpack_public_path__ + "img/googlehome.571cb53c.jpeg";